/* Notes · comportamento da home no layout da GNUHR.
   NotesHome.init(root, opts) pode rodar no documento inteiro ou num trecho.
   opts.scroller: elemento que rola (padrão: a janela). opts.demo: sacola e cadastro de mentira. */
(function () {
  "use strict";
  if (window.NotesHome) return;

  function qa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function q(root, sel) { return root.querySelector(sel); }

  /* ---------- holofote (desktop) ---------- */
  function spot(d, i) {
    d.classList.toggle("is-spot", !!i);
    qa(d, ".is-on").forEach(function (e) { e.classList.remove("is-on"); });
    if (i) qa(d, '[data-i="' + i + '"]').forEach(function (e) { e.classList.add("is-on"); });
  }

  /* ---------- cor e tamanho ---------- */
  function initOpcoes(idx, item) {
    var form = q(item, "form.ns-add");
    if (!form) return;
    var variants = [];
    try { variants = JSON.parse(q(item, "[data-ns-variants]").textContent); } catch (e) { variants = []; }
    var idInput = q(form, 'input[name="id"]');
    var btn = q(form, "button.ns-btn");
    var i = item.getAttribute("data-i");
    function atualizar() {
      if (!variants.length || !idInput || !btn) return;
      var sel = qa(form, ".ns-opt").map(function (fs) { var c = q(fs, "input:checked"); return c ? c.value : null; });
      var v = variants.find(function (vv) { return sel.every(function (val, k) { return val === null || vv.options[k] === val; }); });
      if (!v) return;
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.classList.toggle("is-off", !v.available);
      btn.textContent = v.available ? btn.getAttribute("data-label") : btn.getAttribute("data-off");
      var img = v.featured_image && (v.featured_image.src || v.featured_image);
      if (img) qa(idx, '.ns-th[data-i="' + i + '"] img, .ns-mr[data-i="' + i + '"] img').forEach(function (el) { el.src = img; el.removeAttribute("srcset"); });
    }
    form.addEventListener("change", atualizar);
    atualizar();
  }

  /* ---------- ordenar e filtrar: redistribui as peças nas duas metades ---------- */
  function relayout(idx, st) {
    var its = qa(idx, ".ns-it");
    var key = {
      nome: function (e) { return e.getAttribute("data-nome") || ""; },
      data: function (e) { return -(+e.getAttribute("data-data") || 0); },
      preco: function (e) { return +e.getAttribute("data-preco") || 0; }
    }[st.sort];
    its.sort(function (a, b) {
      if (key) { var ka = key(a), kb = key(b); if (ka < kb) return -1; if (ka > kb) return 1; }
      return a.getAttribute("data-i") - b.getAttribute("data-i");
    });
    var vis = its.filter(function (e) { return !st.tipo || e.getAttribute("data-type") === st.tipo; });
    var half = Math.ceil(vis.length / 2);
    var la = q(idx, '.ns-ls[data-col="a"]'), lb = q(idx, '.ns-ls[data-col="b"]');
    var ta = q(idx, '.ns-th-col[data-col="a"]'), tb = q(idx, '.ns-th-col[data-col="b"]');
    var ml = q(idx, ".ns-m__list");
    its.forEach(function (e) {
      var i = e.getAttribute("data-i"), k = vis.indexOf(e), show = k > -1;
      var th = q(idx, '.ns-th[data-i="' + i + '"]'), mr = q(idx, '.ns-mr[data-i="' + i + '"]');
      e.hidden = !show; if (th) th.hidden = !show; if (mr) mr.hidden = !show;
      if (!show) return;
      if (la && lb) (k < half ? la : lb).appendChild(e);
      if (th && ta && tb) (k < half ? ta : tb).appendChild(th);
      if (mr && ml) ml.appendChild(mr);
    });
    if (idx.__nsAtivar) idx.__nsAtivar(true);
  }

  function initControles(idx) {
    var st = { sort: null, tipo: null };
    function marcar(attr, val) {
      qa(idx, "[" + attr + "]").forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute(attr) === val ? "true" : "false"); });
    }
    qa(idx, "[data-ns-sort]").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = b.getAttribute("data-ns-sort");
        st.sort = st.sort === v ? null : v;
        marcar("data-ns-sort", st.sort); relayout(idx, st);
      });
    });
    qa(idx, "[data-ns-filtro]").forEach(function (b) {
      b.addEventListener("click", function () {
        var v = b.getAttribute("data-ns-filtro");
        st.tipo = st.tipo === v ? null : v;
        marcar("data-ns-filtro", st.tipo); relayout(idx, st);
      });
    });
  }

  /* ---------- celular: a linha que passa pela faixa vira destaque ---------- */
  function initCelular(idx, m, opts) {
    var scroller = opts.scroller || window;
    var big = q(m, "[data-ns-big]"), band = q(m, "[data-ns-band]");
    function vh() {
      idx.style.setProperty("--ns-vh", (scroller === window ? window.innerHeight : scroller.clientHeight) + "px");
      if (scroller !== window || m.offsetParent === null) return;
      var fim = m.getBoundingClientRect().bottom + window.scrollY;
      idx.style.setProperty("--ns-resto", Math.max(0, document.documentElement.scrollHeight - fim) + "px");
    }
    vh();
    window.addEventListener("resize", vh);
    window.addEventListener("load", vh);
    var atual = null;
    function ativar(forcar) {
      if (m.offsetParent === null) return;
      var cy = band.getBoundingClientRect().top + 32;
      var best = null, bd = Infinity;
      qa(m, ".ns-mr:not([hidden])").forEach(function (r) {
        var rr = r.getBoundingClientRect();
        var d = Math.abs(rr.top + Math.min(32, rr.height / 2) - cy);
        if (d < bd) { bd = d; best = r; }
      });
      if (!best || (best === atual && !forcar)) return;
      if (atual) atual.classList.remove("is-on");
      atual = best; best.classList.add("is-on");
      var src = best.getAttribute("data-img");
      if (src) { big.innerHTML = '<img alt="">'; big.firstChild.src = src; }
      else { var th = q(best, ".ns-mr__th"); big.innerHTML = th ? th.innerHTML : ""; }
    }
    idx.__nsAtivar = ativar;
    var pend = false;
    (scroller === window ? window : scroller).addEventListener("scroll", function () {
      if (pend) return; pend = true;
      requestAnimationFrame(function () { pend = false; ativar(); });
    }, { passive: true });
    m.classList.add("is-loading");
    setTimeout(function () { m.classList.remove("is-loading"); ativar(true); }, opts.splash == null ? 1100 : opts.splash);

    var btn = q(m, "[data-ns-menu-btn]"), menu = q(m, "[data-ns-menu]");
    if (btn && menu) {
      btn.addEventListener("click", function () {
        var abrir = menu.hidden;
        menu.hidden = !abrir;
        btn.setAttribute("aria-expanded", abrir ? "true" : "false");
        m.classList.toggle("is-menu", abrir);
      });
    }
  }

  function initIndice(root, opts) {
    qa(root, "[data-ns-idx]:not([data-ns-ready])").forEach(function (idx) {
      idx.setAttribute("data-ns-ready", "");
      var d = q(idx, ".ns-d"), m = q(idx, ".ns-m");
      if (d) {
        qa(d, ".ns-th, .ns-it").forEach(function (el) {
          el.addEventListener("mouseenter", function () { spot(d, el.getAttribute("data-i")); });
          el.addEventListener("mouseleave", function () { spot(d, null); });
        });
      }
      qa(idx, ".ns-it").forEach(function (it) { initOpcoes(idx, it); });
      initControles(idx);
      if (m) initCelular(idx, m, opts);
    });
  }

  /* ---------- sacola ---------- */
  function contar(n) {
    qa(document, "[data-ns-cart-count]").forEach(function (el) { el.textContent = n; });
    qa(document, ".ns-cart, .ns-m__cart").forEach(function (el) { el.classList.toggle("has-items", n > 0); });
  }
  function initSacola(root, demo) {
    qa(root, "form.ns-add:not([data-ns-ready])").forEach(function (form) {
      form.setAttribute("data-ns-ready", "");
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = q(form, "button.ns-btn");
        function feito() {
          if (!btn) return;
          btn.textContent = btn.getAttribute("data-ok") || "adicionado";
          setTimeout(function () { btn.textContent = btn.getAttribute("data-label"); }, 2000);
        }
        if (demo) {
          var el = q(document, "[data-ns-cart-count]");
          contar((parseInt(el && el.textContent, 10) || 0) + 1);
          feito();
          return;
        }
        if (btn) btn.disabled = true;
        fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
          .then(function (r) { if (!r.ok) throw new Error("add"); return fetch("/cart.js"); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            contar(cart.item_count); feito();
            document.dispatchEvent(new CustomEvent("ns:cart-updated", { detail: cart }));
          })
          .catch(function () { form.submit(); })
          .finally(function () { if (btn) btn.disabled = false; });
      });
    });
  }

  /* ---------- rodapé: relógio e cadastro ---------- */
  function initRelogio(root) {
    qa(root, "[data-ns-clock]:not([data-ns-ready])").forEach(function (el) {
      el.setAttribute("data-ns-ready", "");
      function p(n) { return (n < 10 ? "0" : "") + n; }
      function tick() {
        var d = new Date();
        el.textContent = "" + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds());
      }
      tick(); setInterval(tick, 1000);
    });
  }
  function initCadastro(root, demo) {
    if (!demo) return;
    qa(root, "form.ns-news").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var out = q(form.parentNode, "[data-ns-news-msg]");
        if (out) out.textContent = "pronto, você está na lista.";
      });
    });
  }

  window.NotesHome = {
    init: function (root, opts) {
      opts = opts || {};
      root = root || document;
      initIndice(root, opts);
      initSacola(root, !!opts.demo);
      initRelogio(root);
      initCadastro(root, !!opts.demo);
    }
  };

  if (!window.NotesHomeManual) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () { window.NotesHome.init(document); });
    } else {
      window.NotesHome.init(document);
    }
    document.addEventListener("shopify:section:load", function (e) { window.NotesHome.init(e.target); });
  }
})();
